import { useEffect } from 'react';

import { AckMessage, WindowMessage, WindowMessageType } from 'src/types/message';

type ExpectedMessageType = Exclude<WindowMessageType, WindowMessageType.Ack>;
type ExpectedMessage = Extract<WindowMessage, { type: ExpectedMessageType }>;

const useOneTimeMessageListener = <T extends ExpectedMessage>(
  messageType: ExpectedMessageType,
  callback: (message: T) => void
) => {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (event.origin !== window.location.origin) return;

      const message = event.data;

      const isExpectedMessage = (messageData: any): messageData is T => {
        return messageData?.type === messageType;
      };

      if (isExpectedMessage(message)) {
        callback(message);

        const responseMessage: AckMessage = {
          type: WindowMessageType.Ack,
          respondingTo: message.type,
        };
        window.opener?.postMessage(responseMessage);
        window.removeEventListener('message', handleMessage);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [messageType, callback]);
};

export default useOneTimeMessageListener;
